import { ClipboardCheck, Hourglass, Sparkles, Star } from "lucide-react";
import { Reveal } from "../site/Reveal";

const PILLARS = [
  {
    icon: ClipboardCheck,
    title: "Operational Systems Audit",
    body: "A top-to-bottom review of the workflows, handoffs, and daily rituals that decide whether your property runs on systems — or on you.",
  },
  {
    icon: Sparkles,
    title: "Guest Experience Design",
    body: "Choreographed arrival-to-farewell journeys, service standards, and the small ceremonies guests remember — and review.",
  },
  {
    icon: Star,
    title: "Reputation & Review Engine",
    body: "Five-star review generation, response discipline, and ranking recovery — hospitality-grade reputation management, built in.",
  },
  {
    icon: Hourglass,
    title: "Owner Time-Wealth Recovery",
    body: "Delegation architecture, automation, and decision frameworks that return owner hours to growth — or to life.",
  },
];

export default function AdvisoryCards() {
  return (
    <section id="advisory" data-testid="advisory-cards" className="relative bg-background text-foreground py-24 lg:py-32 grain overflow-hidden">
      <div className="container-luxe relative z-10">
        <Reveal>
          <p className="overline flex items-center gap-3">
            <span className="h-px w-8 bg-[var(--gold)]" />
            Core Advisory
          </p>
          <h2 className="mt-6 max-w-2xl serif text-[clamp(1.9rem,4vw,3.2rem)] leading-[1.06] tracking-tight">
            Four disciplines.{" "}
            <span className="italic text-gold">One transformed operation.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 gap-px bg-border border border-border">
          {PILLARS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.08}>
              <div
                data-testid={`advisory-card-${i}`}
                className="group h-full bg-background p-9 lg:p-11 transition-[background-color,transform] duration-400 hover:bg-[var(--blush)]/70 hover:-translate-y-1"
              >
                <p.icon size={22} className="text-[var(--gold)]" strokeWidth={1.5} />
                <p className="mt-2 overline">0{i + 1}</p>
                <h3 className="mt-4 serif text-xl lg:text-2xl tracking-tight">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{p.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
